import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalList, LegalPage, LegalSection } from "@/components/legal/LegalPage";

export const Route = createFileRoute("/privacidad")({
  component: PrivacyRoute,
  head: () => ({
    meta: [
      { title: "Política de privacidad — Sift Trip" },
      { name: "description", content: "Cómo SiftTrip maneja los datos personales de sus usuarios." },
    ],
  }),
});

function PrivacyRoute() {
  return (
    <LegalPage title="Politica de privacidad" eyebrow="Datos personales">
      <LegalSection title="1. Responsable">
        <p>
          SiftTrip, marca en proceso de constitucion, sera responsable del
          tratamiento de los datos personales que recolecte directamente en la
          plataforma bajo el nombre comercial "SiftTrip". La razon social,
          domicilio, identificacion tributaria y correo formal de privacidad se
          actualizaran tan pronto la entidad sea constituida. Mientras tanto,
          cualquier solicitud relacionada con datos personales puede dirigirse a{" "}
          <a href="mailto:contact@siftrip.com" className="font-semibold text-[#E8194B]">
            contact@siftrip.com
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="2. Datos que podemos tratar">
        <LegalList
          items={[
            "Datos de cuenta (guardados en nuestra base de datos, alojada en Supabase): correo electronico, nombre o display name, idioma y moneda preferidos y, de forma opcional, telefono, pais de residencia, tipo de viajero preferido e intereses de viaje.",
            "Datos de autenticacion: si el usuario inicia sesion con Google, recibimos los datos basicos de perfil y correo que Google comparte para ese inicio de sesion, gestionado por Supabase Auth. No accedemos a otra informacion de la cuenta de Google del usuario.",
            "Datos de uso guardados en la cuenta: busquedas recientes, experiencias guardadas (wishlist) y comparaciones guardadas.",
            "Texto libre de busqueda: cuando el usuario escribe una consulta en lenguaje natural (por ejemplo, \"Milan vinedos romance\"), ese texto puede enviarse a un proveedor externo de inteligencia artificial (Anthropic) para interpretar la intencion de viaje.",
            "Datos de busqueda estructurados: destino, fechas, viajeros, edades de ninos cuando se ingresen, idioma, moneda, filtros e intereses de viaje.",
            "Datos tecnicos: direccion IP aproximada, dispositivo, navegador, logs de seguridad, errores, rendimiento y eventos de uso.",
            "Datos de soporte: mensajes, solicitudes, reclamos, respuestas y archivos que el usuario decida enviar.",
            "Datos de analitica: interacciones agregadas o seudonimizadas para entender uso del producto y mejorar resultados, incluyendo un identificador anonimo de visitante guardado en el navegador.",
          ]}
        />
      </LegalSection>

      <LegalSection title="3. Finalidades">
        <LegalList
          items={[
            "Prestar la busqueda y comparacion de experiencias.",
            "Personalizar resultados por destino, fecha, viajeros, idioma, moneda e intereses.",
            "Guardar preferencias y mejorar la experiencia de usuario.",
            "Medir rendimiento, disponibilidad, errores, abusos y seguridad.",
            "Responder solicitudes de soporte, PQR o comunicaciones del usuario.",
            "Cumplir obligaciones legales, contables, de seguridad o de consumidor cuando apliquen.",
            "Enviar comunicaciones operativas o de producto, siempre respetando las opciones de baja cuando apliquen.",
          ]}
        />
      </LegalSection>

      <LegalSection title="4. Base legal y autorizacion">
        <p>
          En Colombia, cuando aplique, el tratamiento se realizara con
          autorizacion previa, informada y verificable del titular, salvo las
          excepciones legales. Para usuarios en otras jurisdicciones, SiftTrip
          usara bases como consentimiento, ejecucion de una relacion con el
          usuario, interes legitimo, seguridad y cumplimiento legal, segun
          corresponda.
        </p>
      </LegalSection>

      <LegalSection title="5. Terceros y proveedores">
        <p>
          Podemos compartir datos estrictamente necesarios con los siguientes
          terceros:
        </p>
        <LegalList
          items={[
            "Supabase: aloja nuestra base de datos y gestiona la autenticacion de usuarios, incluyendo el inicio de sesion con Google y los enlaces magicos por correo.",
            "Google: como proveedor de inicio de sesion (OAuth), unicamente si el usuario elige iniciar sesion con Google.",
            "Viator, GuruWalk y otros proveedores que se sumen en el futuro: cuando el usuario abre o continua hacia una experiencia, esos proveedores reciben los parametros necesarios para mostrarla o procesarla, y tratan los datos de esa interaccion bajo su propia politica de privacidad.",
            "Anthropic: proveedor de inteligencia artificial usado para interpretar el texto libre que el usuario escribe al buscar.",
            "Proveedores de hosting e infraestructura (por ejemplo Vercel para el sitio y Render para el backend): necesarios para operar la plataforma.",
          ]}
        />
        <p>
          Cuando el usuario abandona SiftTrip y reserva con un proveedor
          externo, ese proveedor trata sus datos bajo su propia politica de
          privacidad, no bajo esta.
        </p>
      </LegalSection>

      <LegalSection title="6. Pagos">
        <p>
          SiftTrip no almacena datos de tarjetas ni procesa pagos hoy. Toda
          transaccion de pago ocurre directamente en el sitio del proveedor
          externo (por ejemplo Viator o GuruWalk), bajo sus propias medidas de
          seguridad de pago.
        </p>
      </LegalSection>

      <LegalSection title="7. Transferencias internacionales">
        <p>
          La infraestructura tecnica y algunos proveedores pueden estar ubicados
          fuera de Colombia. Al usar SiftTrip, el usuario entiende que sus datos
          pueden ser tratados o almacenados en otros paises, con medidas
          razonables de seguridad y contratos aplicables cuando correspondan.
        </p>
      </LegalSection>

      <LegalSection title="8. Cookies y tecnologias similares">
        <p>
          Usamos cookies o tecnologias similares para autenticacion,
          preferencias, analitica, seguridad, rendimiento y medicion de enlaces.
          El detalle esta en la{" "}
          <Link to="/cookies" className="font-semibold text-[#E8194B]">
            politica de cookies
          </Link>
          .
        </p>
      </LegalSection>

      <LegalSection title="9. Conservacion">
        <p>
          Conservaremos datos mientras sean necesarios para prestar el servicio,
          cumplir finalidades informadas, atender obligaciones legales, resolver
          disputas, prevenir fraude o mantener seguridad. Los datos agregados o
          anonimizados podran conservarse para analitica y mejora del producto.
        </p>
        <p>
          Hoy no existe un flujo de autoeliminacion de cuenta dentro de la
          plataforma. Mientras se construye, la eliminacion de una cuenta y de
          los datos asociados a ella (busquedas recientes, wishlist,
          comparaciones guardadas) se gestiona manualmente al recibir una
          solicitud por{" "}
          <a href="mailto:contact@siftrip.com" className="font-semibold text-[#E8194B]">
            contact@siftrip.com
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="10. Derechos del titular">
        <p>
          El usuario puede solicitar acceso, actualizacion, rectificacion,
          supresion, prueba de autorizacion, informacion sobre uso de sus datos,
          revocatoria de autorizacion y presentar quejas ante la autoridad
          competente cuando aplique. Estos derechos pueden ejercerse escribiendo
          a{" "}
          <a href="mailto:contact@siftrip.com" className="font-semibold text-[#E8194B]">
            contact@siftrip.com
          </a>
          . El canal formal se actualizara con la razon social tan pronto la
          entidad quede constituida.
        </p>
      </LegalSection>

      <LegalSection title="11. Seguridad">
        <p>
          SiftTrip implementara medidas razonables de seguridad tecnica y
          organizacional. Ningun sistema es absolutamente seguro; el usuario debe
          proteger sus credenciales y avisar si sospecha uso no autorizado.
        </p>
      </LegalSection>

      <LegalSection title="12. Menores de edad">
        <p>
          SiftTrip no esta dirigido a menores que actuen sin adulto responsable.
          Las edades de ninos pueden usarse solo para filtrar o adaptar
          experiencias familiares y no deben usarse para crear perfiles
          sensibles innecesarios.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
